import { createModulePerms } from '@wit-support/ui-domain';
/**
 * Fail-closed defaults: outside the provider (and in any test that doesn't
 * care) nothing is granted, so a gated control never flashes for an operator
 * whose grant we haven't confirmed. The server stays the real gate.
 */
export const CONVERSATIONS_PERMS_NONE = {
    canReply: false,
    canMerge: false,
    canReclassify: false,
    canBlacklist: false,
    canViewPipelineSteps: false,
    canViewIdentityHistory: false,
    canSearchIdentity: false,
    canAttachIdentity: false,
    canReadSubscription: false,
    canCancelSubscription: false,
    canReadPortraits: false,
    canReadProductUsage: false,
    canReadChargebacks: false,
    canOverrideSenderCapacity: false,
    canReadSettings: false,
    canTag: false,
    canComment: false,
    canManageComments: false,
    currentAdminDisplayName: null,
    currentAdminId: null,
};
const { Provider: ConversationsModulePermsProvider, usePerms: useConversationsPerms } = createModulePerms(CONVERSATIONS_PERMS_NONE);
export { ConversationsModulePermsProvider, useConversationsPerms };
//# sourceMappingURL=perms.js.map